(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function initCompare(el) {
    if (el.dataset.iccReady) return;
    el.dataset.iccReady = "1";
    var handle = el.querySelector("[data-image-compare-handle]");
    if (!handle) return;

    var m = (el.getAttribute("style") || "").match(/--icc-pos:\s*([\d.]+)%/);
    var currentPos = m ? parseFloat(m[1], 10) : 50;
    if (isNaN(currentPos)) currentPos = 50;

    function setPos(pct) {
      currentPos = clamp(pct, 0, 100);
      el.style.setProperty("--icc-pos", currentPos + "%");
      handle.setAttribute("aria-valuenow", String(Math.round(currentPos)));
    }

    setPos(currentPos);

    function pctFromClientX(clientX) {
      var r = el.getBoundingClientRect();
      if (r.width <= 0) return currentPos;
      return ((clientX - r.left) / r.width) * 100;
    }

    var dragging = false;

    function onPointerDown(e) {
      if (e.button != null && e.button !== 0) return;
      dragging = true;
      try {
        el.setPointerCapture(e.pointerId);
      } catch (err) {}
      setPos(pctFromClientX(e.clientX));
    }

    function onPointerMove(e) {
      if (!dragging) return;
      setPos(pctFromClientX(e.clientX));
    }

    function onPointerUp() {
      dragging = false;
    }

    el.addEventListener("pointerdown", onPointerDown);
    el.addEventListener("pointermove", onPointerMove);
    el.addEventListener("pointerup", onPointerUp);
    el.addEventListener("pointercancel", onPointerUp);
    el.addEventListener("lostpointercapture", onPointerUp);

    handle.addEventListener("keydown", function (e) {
      var step = e.shiftKey ? 25 : 5;
      if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
        e.preventDefault();
        setPos(currentPos - step);
      } else if (e.key === "ArrowRight" || e.key === "ArrowUp") {
        e.preventDefault();
        setPos(currentPos + step);
      } else if (e.key === "Home") {
        e.preventDefault();
        setPos(0);
      } else if (e.key === "End") {
        e.preventDefault();
        setPos(100);
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-image-compare]").forEach(initCompare);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
